// extracted by mini-css-extract-plugin
export default {"wrapper":"CompletionModal_wrapper__6kQJ0","checkIcon":"CompletionModal_checkIcon__iZjOL","doneButton":"CompletionModal_doneButton__cmqeb"};